import { useGlobalStore } from 'store';
import bindActions from 'store/bindActions';
import reducer from 'store/trigger';

const { actions } = reducer;

const useTrigger = () => {
	const { state, dispatch } = useGlobalStore();

	// List of Props
	const { items, error, isLoading } = state.trigger;

	// List of Actions
	const { handleGetDebug, handleClearDebug } = actions;

	// Bind Actions
	const boundActions = bindActions(
		{
			handleGetDebug,
			handleClearDebug,
		},
		dispatch
	);

	return { items, error, isLoading, ...boundActions };
};

export default useTrigger;
